export const is_url = (str) => {
    // eslint-disable-next-line
    const regexp = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
    if (regexp.test(str)) return true;
    else return false;
};
